import JText from './JText';

export default JText;
